(function ($, Cobalt, undefined) {
    Cobalt.Warning =
    {
        initialize: function () {            
            $("#form-field-View-visibility").hide();

            var handleRestrictedToRoles = function() {
                if ($("#field-is-restricted-to-roles").prop("checked")) {
                    $("#field-View-visibility option.j-protection-mode-roleprotected").prop("selected", true).change();
                    $(".restrict-role-container").show();
                } else {
                    $(".restrict-role-container").hide();
                    $("#field-View-visibility option.j-protection-mode-public").prop("selected", true).change();
                }
            };

            $("#field-is-restricted-to-roles").on("change", handleRestrictedToRoles);
            handleRestrictedToRoles();

            var handlePermanentDuration = function() {
                var $that = this !== undefined ? $(this) : $("div.permanent-duration .permanent-field input");
                if ($that.prop("checked")) {
                    $that.parents(".permanent-duration").find(".time-span-container > input,select").prop('disabled', true);
                } else {
                    $that.parents(".permanent-duration").find(".time-span-container > input,select").prop('disabled', false);
                }
            };

            $("div.permanent-duration .permanent-field input").on("change", handlePermanentDuration);
            handlePermanentDuration();

            var handleDangerZone = function() {
                var $container = $("div.danger-zone-container");
                if ($container.hasClass("collapsed")) {
                    $container.removeClass("collapsed");
                    $container.addClass("expanded");
                    $(".danger-zone").show();
                } else {
                    $container.removeClass("expanded");
                    $container.addClass("collapsed");
                    $(".danger-zone").hide();
                }
            };

            $("div.danger-zone-container .title").on("click", handleDangerZone);
            handleDangerZone();

            // handle the display toggling of the informal message div
            var handleInformalMessageContainer = function () {
                if ($("#field-can-warning").prop("checked")) {
                    $("#informal-message-edit-container").show();
                } else {
                    $("#informal-message-edit-container").hide();
                }
            };

            // listen for any changes to the "allow informal warning" checkbox
            $("#field-can-warning").on("change", handleInformalMessageContainer);
            // make sure the initial display of the informal message edit div is correct
            handleInformalMessageContainer();

            
            // listen for regular message template dropdown changes
            $("#field-warning-message").on("change", function () {
                populateTemplatePreview($(this), "#field-warning-message-preview");
            });

            // listen for informal message template dropdown changes
            $("#field-warning-message-inf").on("change", function () {
                populateTemplatePreview($(this), "#field-warning-message-preview-inf");
            });

            // handle message template dropdown changes
            var populateTemplatePreview = function ($dropdown, previewSelector) {
                // get the value of the dropdown
                var value = $dropdown.val();
                // get the matching preview section by the selector parameter
                var $previewElement = $(previewSelector);

                // if an actual template was selected
                if (value) {
                    // call the url that returns the template
                    $.get(Cobalt.Routes.Instance.CPGetWarningMessageTemplate(value), function (data) {
                        // if a template was returned
                        if (data) {
                            // hard-coded formatting of the spacing between the title and body of the template
                            var templateFormat = "{0}\r\n\r\n{1}".format(data.title, data.body);
                            // set the value of the appropriate element to the formatted template
                            $previewElement.val(templateFormat);
                        }
                    });
                } else { // no template was selected
                    // clear the preview display
                    $previewElement.val("");
                }
            };
        },
        handleWarnForm: function(successFunction) {
            var $form = $(".ajax-warn");
            if ($form.length > 0) {
                $form.ajaxForm({
                    beforeSubmit: function() {
                        $form.find(':submit').attr('disabled', 'disabled');
                    },
                    success: function(result) {
                        if (result.Status === undefined || (result.Status !== undefined && result.Status != "invalid")) {
                            $(".ui-dialog-titlebar-close").click();
                            if (successFunction) {
                                successFunction(result, $form);
                            }
                        } else {
                            $form.find(":submit").removeAttr("disabled");
                            //Cobalt.Forms.displayErrors($form, result.Errors);
                            for (var key in result.Errors) {
                                $('.ui-dialog-footer').prepend('<span class="field-errors">' + result.Errors[key][0] + '</span>');
                            }
                            if ($('.field-errors').is(':visible')) {
                                $('.p-modal-a').addClass('warning-error-visible');
                            }
                        }
                    }
                });
            }
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Warning.js